import {
  ReporteLiderComercialMockUp,
  ResumenLiderComercialMockUp
} from "./ReporteLiderComercial.types";

export const mockResumen: ResumenLiderComercialMockUp = {
  operaciones: 157,
  descuentos: -12,
  alcance: 72.5,
  meta: 200,
  asesores: 8
};

export const mockData: ReporteLiderComercialMockUp[] = [
  {
    numEmpleado: "9801",
    empleado: "Maribel Estrada Garcia",
    ventas: 9,
    reactivaciones: 4,
    integrantes: 3,
    extras: 2,
    rescuentos: 4
  }
];
